import { useMounted } from '@chillibean/component-library';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Switch, useParams } from 'react-router-dom';

import { ProtocolTabLayout } from '../../components/container';
import { fetchProtocol, fetchRoles, fetchFormTemplates } from '../../redux/actions';

export function ProtocolsShowPage(props) {
  const { subRoutes } = props;

  // HOOKS
  // Router
  const { study_protocol_id: studyProtocolId } = useParams();
  // Store
  const dispatch = useDispatch();
  const { account } = useSelector((state) => state.internalReducer.internal);
  // Custom
  const { mounted } = useMounted({ requiredValues: [account] });

  useEffect(() => {
    if (mounted) {
      dispatch(fetchProtocol(studyProtocolId));
      dispatch(fetchRoles()); // TODO: why it is here?
      dispatch(fetchFormTemplates());
    }
  }, [mounted, studyProtocolId]);

  const shortRoute = (r) => ({ name: r.name, path: r.path });
  const routeProps = (match) => ({ match: match, routes: subRoutes.map(shortRoute) });

  return (
    <Switch>
      {subRoutes?.map((route) => {
        return (
          <Route
            key={route.path}
            exact={route.exact}
            path={route.path}
            render={({ match }) => (
              <ProtocolTabLayout {...routeProps(match)}>
                <route.component />
              </ProtocolTabLayout>
            )}
          />
        );
      })}
    </Switch>
  );
}

ProtocolsShowPage.propTypes = {
  subRoutes: PropTypes.arrayOf(
    PropTypes.shape({
      disabled: PropTypes.bool,
      exact: PropTypes.bool,
      name: PropTypes.string,
      path: PropTypes.string,
    }),
  ).isRequired,
};

export default ProtocolsShowPage;
